export default __webpack_public_path__ + "static/media/social_media.ab90ae6e.svg";